import { Flex, Box, IconButton, Text, DataList, DataItem } from '@cad-arc';
import { CloseMapLedgerAndClearSelectedEntityButton } from './close-map-ledger-and-clear-selected-entity-button';
import { FR_EVENT_DETAILS_TABS } from '../../../fr-event-details-page/constants';
import { useOpenEvent } from '../../../common/hooks/use-open-event';
import { CommonSize, getOneSizeSmaller } from '../../../common/helpers/utils';
import { FR_ICON_SIZE, ICON_SIZE } from './constants';
import { colors } from '~/colors/colors';

type EventGeneralInfoBlockProps = {
    eventIcon: string;
    eventPriority?: string;
    agencyEventNumber?: string;
    cfsCode?: string;
    cfsDescription?: string;
    eventId: number;
    showCloseIconButton?: boolean;
    isAssigned?: boolean;
    size?: CommonSize;
};

export function EventGeneralInfoBlock({
    eventIcon,
    eventPriority,
    agencyEventNumber,
    cfsCode,
    cfsDescription,
    eventId,
    isAssigned,
    showCloseIconButton = true,
    size,
}: EventGeneralInfoBlockProps): React.ReactElement {
    const eventTitle = agencyEventNumber ? `Event ${agencyEventNumber}` : 'Loading ...';

    const openEventHandler = useOpenEvent();

    const smallerSize = getOneSizeSmaller(size);
    const iconSize = size === 'lg' ? FR_ICON_SIZE : ICON_SIZE;

    return (
        <Box
            display="grid"
            gridTemplateColumns="auto 1fr auto auto"
            columnGap={1}
            width="100%"
            data-testid="MAP_EVENT_GENERAL_INFO_BLOCK"
        >
            <Flex
                alignItems="center"
                width={iconSize}
                minWidth={iconSize}
                data-testid="MAP_EVENT_ICON"
            >
                <Box position="relative">
                    <img
                        src={eventIcon}
                        alt="icon"
                        width={iconSize}
                        height={iconSize}
                        data-icon-key={isAssigned ? 'Assigned' : 'Unassigned'}
                        data-testid="MAP_EVENT_ICON_IMG"
                    />
                    <Box position="absolute" left="50%" top="50%" transform="translate(-50%,-50%)">
                        <Text fontSize={smallerSize} fontWeight="bold" style={{color: colors.mapLabelText}}>
                            {eventPriority || ''}
                        </Text>
                    </Box>
                </Box>
            </Flex>
            <DataList direction="column" variant="stacked">
                <DataItem
                    dataKey={<Text fontSize={size}>{eventTitle}</Text>}
                    style={{ wordBreak: 'break-word' }}
                    data-testid="MAP_EVENT_TITLE"
                >
                    <Text fontSize={smallerSize}>
                        {cfsCode && cfsDescription && `${cfsCode} - ${cfsDescription}`}
                    </Text>
                </DataItem>
            </DataList>
            {agencyEventNumber && (
                <IconButton
                    aria-label="New window"
                    icon="OpenNewWindow"
                    variant="ghost"
                    size={smallerSize}
                    style={{ margin: '0 0 0 auto' }}
                    data-testid="MAP_OPEN_EVENT_PANEL_BUTTON"
                    onClick={() =>
                        openEventHandler({
                            eventId,
                            frEventDetailsTabName: FR_EVENT_DETAILS_TABS.NARRATIVE,
                        })
                    }
                />
            )}
            {showCloseIconButton && <CloseMapLedgerAndClearSelectedEntityButton />}
        </Box>
    );
}
